/**
 * Размеры страниц списков.
 *
 * Числа продублированы с контрактами (`PAGE_SIZES`, `DEFAULT_PAGE_SIZE`) намеренно: нижний слой не
 * знает правил портала и контракты не импортирует. Расхождение ловит `test/pagination.test.ts` —
 * сервер принимает только эти размеры, и запрос с чужим ответил бы отказом.
 */

/** Размеры, которые предлагает переключатель страницы; совпадают с принимаемыми сервером. */
export const PAGE_SIZE_OPTIONS = [50, 100, 200, 500] as const;

/** Обычный размер страницы на десктопе. */
export const DESKTOP_PAGE_SIZE = 100;

/**
 * На телефоне страница меньше (ADR 0030): карточка занимает столько же места, сколько десяток
 * строк таблицы, и сотня записей — это метры прокрутки и лишний трафик.
 */
export const MOBILE_PAGE_SIZE = 50;

/** Сколько записей запрашивают у справочника, который целиком уходит в выпадающий список. */
export const DICTIONARY_PAGE_SIZE = 500;
